import { Locale } from "../types/ui-types";

export const getFormalLocale = (locale: string): string => {
  switch (locale) {
    case Locale.FI:
      return "fi-FI";
    case Locale.EN:
      return "en-US";
    case Locale.SWE:
      return "sv-SE";
    default:
      return "fi-FI";
  }
};
